<template>
  <div class="home">
    <WelcomePage />
  </div>
</template>

<script>
import WelcomePage from "@/components/WelcomePage.vue";

export default {
  name: "Home",
  components: {
    WelcomePage,
  },
};
</script>
